<template>
   <div  class="lg:w-[250px] w-[200px]">
    <slot></slot>
   </div>
</template>

<script>
export default {
    name:"TableDateWrapper"

}
</script>

<style>

</style>